import { FilterSeparator } from '@sorare/core/src/lib/filters';

export const filterSeparator: FilterSeparator = { type: 'separator' };
export {
  RefineActiveNationalTeam,
  RefineActiveLeague,
  RefineCardEdition,
  RefinePlayer,
  RefineSeason,
  RefineSingleYearSeason,
  RefineBundledSale,
  RefinePlayingStatus,
  RefineSaleType,
  RefineRarity,
  RefineNationality,
  RefineBirthplace,
} from './RefineList';
export { RefineSettlementWallets } from './RefineSettlementWallets';
export { RefineAge, RefineCardPlayerAge } from './RefineAge';
export { RefineCardLevel, RefinePrice } from './RangeSlider';
export { RefineAverageScore } from './RefineAverageScore';
export { RefineAppearances } from './RefineAppearances';
export { RefineSerialNumber } from './RefineSerialNumber';
export { default as RefineCompetitionEligibility } from './RefineCompetitionEligibility';

export { default as NotInLineupFilter } from './NotInLineupFilter';
export { default as CollectibleFilter } from './CollectibleFilter';
export { GameweekFilter, DailyFilter } from './FixtureFilter';
export { default as PromotedCardsFilter } from './PromotedCardsFilter';
export { default as RefineOnSale } from './RefineOnSale';
export { default as AdvancedCardSearch } from './AdvancedCardSearch';
export { default as PromotionalEventFilter } from './PromotionalEventFilter';
export { default as RefineInSeason } from './RefineInSeason';
export {
  AcceptedCurrencyGroup,
  CollectibleGroup,
  PriceGroup,
  RarityGroup,
  SaleGroup,
} from './refineGroups';
export { RefinePosition, RefineMultiplePositions } from './RefinePosition';
